import { BdaDataset } from "../models/BdaDataset";
import { BdaModel } from "../models/BdaModel";
import { BdaService, BdaServiceProperty } from "../models/BdaService";
import { AccessLevel } from "../models/generics";
import { WorkflowMode } from "../models/Workflow";
import client from "./axios";

interface DesignerNode {
  id: number;
  name: string;
  description: string;
  organizationName: string;
  ownerName: string;
  accessLevel: AccessLevel;
  label?: string;
  mode?: WorkflowMode;
  area?: string;
  version?: string;
  location?: string;
  datasetType?: string;
  creationDateTime?: string;
  properties?: BdaServiceProperty[];
}

export const Designer = {
  getServices: (params?: URLSearchParams) => client.get<Array<DesignerNode>>(`${window.__env.GATEWAY_URL}/v1/services`, { params }),
  getService: (id: number, params?: URLSearchParams) => client.get<BdaService>(`${window.__env.GATEWAY_URL}/v1/services/${id}`, { params }),
  getDatasets: (params?: URLSearchParams) => client.get<Array<DesignerNode>>(`${window.__env.GATEWAY_URL}/v1/datasets`, { params }),
  getDataset: (id: number, params?: URLSearchParams) => client.get<BdaDataset>(`${window.__env.GATEWAY_URL}/v1/datasets/${id}`, { params }),
  getModels: (params?: URLSearchParams) => client.get<Array<DesignerNode>>(`${window.__env.GATEWAY_URL}/v1/models`, { params }),
  getModel: (id: number, params?: URLSearchParams) => client.get<BdaModel>(`${window.__env.GATEWAY_URL}/v1/models/${id}`, { params }),
}